// Wall-override bookkeeping for Standard Analytics.
//
// A layer can be driven two ways — four radial walls, or one forced outer Ø —
// and the geometry engine always prefers the Ø (`dOverride > 0 ? dOverride :
// innerD + 2 * wall`). That preference is correct; what was missing was any
// rule for which of the two the user meant LAST.
//
// Without it, a Ø typed once — even retyped identically into a box that was
// pre-filled with the live value — pinned the geometry for good. The 3D kept
// following the per-side walls, so the cable visibly changed shape while Ø,
// section and consumption sat frozen, and only another Ø edit would move them.
//
// The rule here is simply: last edit wins, and a blank means "not overridden".

// Editing a wall releases the Ø pin.
export const putSide = (ov, side, val) => {
  const next = { ...(ov || {}) };
  delete next.diameter;
  next[side] = val;
  return next;
};

// Blank removes the key rather than storing '' — `ov.diameter ?? live` has to
// fall through to the live value, and '' is not nullish.
export const putDiameter = (ov, val) => {
  const next = { ...(ov || {}) };
  delete next.diameter;
  if (String(val ?? '').trim() === '') return next;
  next.diameter = val;
  return next;
};

// A field typed into and then emptied again is not an edit. Keying off the raw
// override object left the "walls edited" badge and the Reset button showing
// after the last value had been cleared, and put the model in 'custom' mode
// with nothing actually overridden.
export const activeEdits = (overrides = {}) => {
  const out = {};
  for (const [key, layer] of Object.entries(overrides || {})) {
    const kept = Object.fromEntries(
      Object.entries(layer || {}).filter(([, v]) => String(v ?? '').trim() !== '')
    );
    if (Object.keys(kept).length) out[key] = kept;
  }
  return out;
};

export const isPinned = val => String(val ?? '').trim() !== '';
